module.exports = __webpack_public_path__ + "img/crush_light_ba_list.7033796d.jpg";